import type { Timeframes } from "../Chart/types";

export enum QuoteType {
	BASIC = "BASIC",
	ADVANCED = "ADVANCED",
}

export const QuoteTypeLabel: Record<QuoteType, string> = {
	[QuoteType.BASIC]: "Basic",
	[QuoteType.ADVANCED]: "Advanced",
};

export type QuoteExpandedCharts = {
	[timeframe in Timeframes]?: boolean;
};
export interface QuoteState {
	ticker?: string;
	color?: string;
	quoteType?: QuoteType;
	expandedCharts?: QuoteExpandedCharts;
}

export type DataField = {
	label: string;
	value?: number | null;
	format: (value?: number | null) => string;
	className?: string;
};
